'use client'

import React, { lazy, useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { category } from '@/constants'

import Banner from './component/Banner'
import Categories from './component/Categories'
// import Quotation from './component/Quotation'
import Loader from '@/components/Loader'

const Quotation = lazy(() => import('./component/Quotation'))

export const isBrowser = () => {
	return typeof window !== 'undefined'
}

/// category

export const getCategory = () => {
	if (isBrowser()) {
		const activeCategory = sessionStorage.getItem('_activeCategory')
		if (activeCategory) {
			return JSON.parse(activeCategory)
		}
		return false
	}
}

export const setCategory = (_items) => {
	sessionStorage.setItem('_activeCategory', JSON.stringify(_items))
}

/// product
export const getFavoriteItem = () => {
	if (isBrowser()) {
		const localfavoriteItems = localStorage.getItem('favoriteItems')
		if (localfavoriteItems) {
			return JSON.parse(localfavoriteItems)
		}
		return false
	}
}

export const setFavoriteItems = (_items) => {
	localStorage.setItem('favoriteItems', JSON.stringify(_items))
}

export const clearFavoriteItems = () => {
	localStorage.clear()
}

const ProductsMain = ({ response, categoryId }) => {
	const [productList, setProductList] = useState(response)
	const [filterProductList, setFilterProductList] = useState([])
	const [selectedProducts, setSelectedProducts] = useState([])
	const [selectedCategory, setSelectedCategory] = useState()
	const [page, setPage] = useState(1)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		if (localStorage.getItem('last_modified') && localStorage.getItem('last_modified') + 1000 * 60 * 60 * 24 * 7 < new Date().getTime()) {
			clearAllItems()
		}
		setFilterProductList(filterProductHandler(response))

		if (getFavoriteItem()) {
			setSelectedProducts(getFavoriteItem())
		} else {
			setSelectedProducts([])
		}
		setLoading(false)
	}, [])

	useEffect(() => {
		if (categoryId) {
			let _category = category.find((item) => item?.slug === unescape(categoryId))
			setSelectedCategory(_category)
		} else {
			setSelectedCategory(category[0])
		}
	}, [categoryId])

	useEffect(() => {
		const _productList = filterProductHandler(productList)
		setFilterProductList(_productList)
	}, [selectedCategory])

	const filterProductHandler = (_items) => {
		return selectedCategory?.commodity_id !== 0 ? _items.filter((item) => selectedCategory?.commodity_id == item?.commodity_id) : _items
	}

	const addOrderItemHandler = (orderItem) => {
		const _orderItem = [...selectedProducts, { ...orderItem, required_weight: '0' }]
		setSelectedProducts(_orderItem)
		setFavoriteItems(_orderItem)
		localStorage.setItem('last_modified', new Date().getTime())
	}

	const removeOrderItemHandler = (removeItem) => {
		if (page === 2) return
		const _removeItem = selectedProducts?.filter((item) => item?.category_id !== removeItem?.category_id)
		setSelectedProducts(_removeItem)
		setFavoriteItems(_removeItem)
	}

	const clearAllItems = () => {
		clearFavoriteItems()
		setSelectedProducts([])
		setPage(1)
	}

	return (
		<Container fluid='lg'>
			<Banner />
			<Categories
				category={category}
				selectedCategory={selectedCategory}
				selectedProducts={selectedProducts}
				setSelectedCategory={setSelectedCategory}
				page={page}
				loading={loading}
			/>
			{loading ? (
				<Loader />
			) : (
				<Quotation
					filterProductList={filterProductList}
					selectedProducts={selectedProducts}
					selectedCategory={selectedCategory}
					addOrderItemHandler={addOrderItemHandler}
					removeOrderItemHandler={removeOrderItemHandler}
					page={page}
					updatePage={(pg) => setPage(pg)}
					loading={loading}
					clearAllItems={clearAllItems}
				/>
			)}
		</Container>
	)
}

export default ProductsMain
